import { Link as ReactLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Providers/AuthProvider';
import {
  Space,
  Layout,
  Button,
  Checkbox,
  Form,
  Input,
  Alert,
  theme,
  Tour,
} from 'antd';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import type { GetRef, TourProps } from 'antd';

import { KeyOutlined } from '@ant-design/icons';

import style from './LoginPage.module.css';
import { AuthResultFromServer } from '../../Providers/AuthResultFromServer';
import { useEffect, useRef, useState } from 'react';
import { authService, serviceBundler } from '../../App';
import { UserModelSalt } from '../../Models/Auth/UserModelSalt';
import { useTranslation } from 'react-i18next';
import HeaderBar from '../../Components/Header/HeaderBar';
import Link from 'antd/es/typography/Link';
import { HttpHelper } from '../../Helpers/HttpHelper';
import FooterBar from '../../Components/Footer/FooterBar';
import { TourHelper } from '../../Helpers/TourHelper';

const { useToken } = theme;

interface AuthFormData {
  email: string;
  password: string;
}

const RenderLink = (bindedFunction: Function, textLink: string) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'start' }}>
      <Link
        style={{
          marginBottom: '10px',
          marginLeft: '130px',
          color: '#C1D202',
        }}
        onClick={() => bindedFunction()}
      >
        {textLink}
      </Link>
    </div>
  );
};

const RenderForgetPassword = (bindedFunction: Function, textLink: string) => {
  return (
    <Link
      style={{
        marginBottom: '20px',
        marginLeft: '80px',
        color: '#C1D202',
      }}
      onClick={() => bindedFunction()}
    >
      {textLink}
    </Link>
  );
};

const RenderAlert = (showAlert: boolean, alertMessage: string) => {
  if (!showAlert) {
    return;
  }
  return (
    <Alert
      className={style.renderPositionAlert}
      message={alertMessage}
      showIcon
      type="error"
    />
  );
};

const LoginPage = () => {
  const { i18n, t } = useTranslation();
  const { token } = useToken();

  const [form] = Form.useForm();

  const [alertLogin, showAlertLogin] = useState(false);
  const [passwordReset, showPasswordReset] = useState(false);

  const [loadingForResult, setLoadingForResult] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();
  let auth = useAuth();

  let from = location.state?.from?.pathname || '/';

  const refStep1 = useRef<any>(null);
  const refStep2 = useRef<any>(null);
  const refStep3 = useRef<any>(null);

  const [currentTourStep, setCurrentTourStep] = useState<number>(0);

  useEffect(() => {
    if (authService.GetCurrentEmail() != null) {
      navigate('/profile');
    }

    if (serviceBundler.tourService.tourLoginPageActive) {
      setCurrentTourStep(0);
      const timeout = setTimeout(() => {
        setCurrentTourStep(1);
      }, 100);
    }
  }, [serviceBundler.themeService.IsDarkMode]);

  useEffect(() => {
    serviceBundler.tourService.TourLoginPageSubject.subscribe((value) => {
      if (value) {
        setCurrentTourStep(0);
        if (serviceBundler.tourService.tourLoginPageActive) {
          const timeout = setTimeout(() => {
            setCurrentTourStep(1);
          }, 100);
        }
      }
    });
  }, [0]);

  const steps: TourProps['steps'] = [
    TourHelper.CreateTourSteps(
      t,
      'Login pagina',
      'Hier kun je inloggen op het systeem',
      'top',
      refStep1.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Email adres',
      'Vul hier je email adres in, dit is je gebruikersnaam',
      'top',
      refStep1.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Wachtwoord',
      'Vul hier je wachtwoord in, dit is het wachtwoord dat ingesteld is bij het registreren',
      'top',
      refStep2.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Login knop',
      'Hier kun je inloggen, klik op de knop om in te loggen',
      'top',
      refStep3.current,
    ),
  ];

  const handleLogin = (result: AuthResultFromServer) => {
    if (result.passwordCorrect) {
      navigate(from, { replace: true });
    } else {
      showAlertLogin(true);
    }
    setLoadingForResult(false);
  };

  const BackToHome = () => {
    navigate('/');
  };

  const handleSubmit = (values: AuthFormData) => {
    setLoadingForResult(true);
    var newAuthData = new UserModelSalt();
    newAuthData.email = values.email;
    newAuthData.password = values.password;

    auth.signin(newAuthData, handleLogin);
  };

  const onFinish = (values: AuthFormData) => {
    handleSubmit(values);
  };

  const Login = () => {
    showPasswordReset(false);
  };

  const ForgetPassword = () => {
    showPasswordReset(true);
    showAlertLogin(false);
  };

  const NavigateToPasswordReset = () => {
    var url = HttpHelper.GetUrlBaseHome() + 'login';
    window.location.href = url;
  };

  const StartSpecicifcTour = (step: number) => {
    if (currentTourStep == step) {
      return true;
    }
    return false;
  };

  const TourReady = () => {
    setCurrentTourStep(0);
    serviceBundler.tourService.EndLoginPageTour();
  };

  return (
    <Space direction="vertical" style={{ width: '100vw', height: '100vh' }}>
      <Layout>
        <Tour
          open={StartSpecicifcTour(1)}
          onClose={() => TourReady()}
          steps={steps}
        />
        <Header className={style.headerStyle}>
          <HeaderBar></HeaderBar>
        </Header>

        <Content
          style={{ backgroundColor: token?.colorPrimaryBg }}
          className={style.globalBlock}
        >
          <div className={style.middleBlock}>
            <>
              {RenderAlert(alertLogin, 'Wachtwoord onjuist')}

              <Form
                name="basic"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                className={style.formWidth}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                onChange={() => {
                  showAlertLogin(false);
                }}
                form={form}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginLeft: '-130px',
                  }}
                >
                  {passwordReset && RenderLink(Login, t('backToLogin'))}
                </div>

                {passwordReset && (
                  <Button
                    icon={<KeyOutlined />}
                    style={{ width: 300, marginTop: 30 }}
                    type="dashed"
                    onClick={() => NavigateToPasswordReset()}
                  >
                    {t('resetPassword')}
                  </Button>
                )}

                {!passwordReset && (
                  <div ref={refStep1}>
                    <Form.Item
                      label={t('emailAddress')}
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: 'Geef je gebruikersnaam',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                )}

                {!passwordReset &&
                  RenderForgetPassword(
                    ForgetPassword,
                    t('forgetPassword') + '?',
                  )}

                {!passwordReset && (
                  <>
                    <div ref={refStep2}>
                      <Form.Item
                        label={t('password')}
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: 'Geef je wachtwoord',
                          },
                        ]}
                      >
                        <Input.Password />
                      </Form.Item>
                    </div>

                    <Form.Item
                      name="remember"
                      valuePropName="checked"
                      className={style.rememberText}
                    >
                      <Checkbox>{t('rememberMe')}</Checkbox>
                    </Form.Item>
                    <div ref={refStep3}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingForResult}
                      >
                        {t('login')}
                      </Button>
                    </div>
                  </>
                )}
              </Form>
            </>
          </div>
        </Content>
        <Footer className={style.footerStyle}>
          <FooterBar></FooterBar>
        </Footer>
      </Layout>
    </Space>
  );
};

export default LoginPage;
